// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JRY_","content":"styles_content__1-bNu","tableWrap":"styles_tableWrap__2-Yza"};